export default __webpack_public_path__ + "static/media/cali-wataboi.a379b9b0.mp3";